module.exports = __webpack_public_path__ + "media/4x3/nz-3241e927.svg";